import apiClient from './apiClient';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

export const dokumentApi = {
  // Dokument hochladen
  uploadDokument: async (formData) => {
    const response = await apiClient.post('/dokumente/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Alle Dokumente eines Kunden abrufen
  getDokumenteByKunde: async (kundeId, { inkludiereAnsprechpartner } = {}) => {
    const params = inkludiereAnsprechpartner ? '?inkludiereAnsprechpartner=true' : '';
    const response = await apiClient.get(`/dokumente/kunde/${kundeId}${params}`);
    return response.data;
  },

  // Einzelnes Dokument abrufen
  getDokument: async (id) => {
    const response = await apiClient.get(`/dokumente/${id}`);
    return response.data;
  },

  // Dokument aktualisieren
  updateDokument: async (id, data) => {
    const response = await apiClient.put(`/dokumente/${id}`, data);
    return response.data;
  },

  // Dokument löschen
  deleteDokument: async (id) => {
    const response = await apiClient.delete(`/dokumente/${id}`);
    return response.data;
  },

  // Download URL generieren
  getDownloadUrl: (id) => {
    const token = localStorage.getItem('token');
    return `${API_URL}/dokumente/download/${id}?token=${token}`;
  }
};
